module.exports = __webpack_public_path__ + "static/media/bright-1-768x591.1bde4cd1.jpg";